// Country-mismatch drawer — piece 3 of 3 (AAS-168 pre-paint restructure).
// UI only. Detection lives in snippets/geo-detect.liquid (head) and routing in
// snippets/geo-redirect.liquid (body-top); this script consumes window.__armadaGeo,
// it never issues its own geo request. On the homepage a cache hit has already
// auto-redirected before this deferred script runs, so this mainly powers the prompt
// on other pages and on the first (cache-miss) visit.
(() => {
  // Never run inside the theme editor.
  if (window.Shopify && window.Shopify.designMode) return;

  // Shared "stay here" key — see geo-detect.liquid / geo-redirect.liquid / market-selector.js.
  const DISMISS_KEY = 'marketMismatchDismissed';

  const isDismissed = () => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const setDismissed = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (error) {
      /* storage unavailable — nothing to persist */
    }
  };

  // Already dismissed this session — don't prompt again.
  if (isDismissed()) return;

  const geo = window.__armadaGeo;
  const modal = document.getElementById('MarketMismatchDrawer');
  if (!geo || !modal || typeof geo.resolve !== 'function') return;

  const { message } = modal.dataset;

  // English region name for the detected ISO code (e.g. "JP" -> "Japan").
  const regionName = (iso) => {
    try {
      const display = new Intl.DisplayNames(['en'], { type: 'region' });
      return display.of(iso) || iso;
    } catch (error) {
      return iso;
    }
  };

  // Detected country: the synchronous cache if present, otherwise await the fetch the
  // head already started. Never our own request.
  const detectedPromise = geo.cached
    ? Promise.resolve(geo.cached)
    : (geo.promise || Promise.resolve(null));

  detectedPromise.then((detected) => {
    const decision = geo.resolve(detected);
    // No suggestion (unlisted, same country, or same market) — nothing to show.
    if (!decision) return;

    // Fill the brand-localized message + flag.
    const messageEl = modal.querySelector('[data-mismatch-message]');
    if (messageEl) {
      messageEl.textContent = (message || '').replace('__country__', regionName(detected));
    }

    const flagEl = modal.querySelector('[data-mismatch-flag]');
    if (flagEl && decision.flag) flagEl.src = decision.flag;

    // Wire actions. Switch reuses the shared applySuggestion(); Switch / Stay / close
    // (X, backdrop, Esc) all dismiss for the session.
    const switchBtn = modal.querySelector('[data-mismatch-switch]');
    const stayBtn = modal.querySelector('[data-mismatch-stay]');
    const closeBtn = modal.querySelector('[id^="ModalClose-"]');

    switchBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      setDismissed();
      geo.applySuggestion(decision);
    });

    stayBtn?.addEventListener('click', () => {
      setDismissed();
      modal.hide();
    });

    closeBtn?.addEventListener('click', setDismissed);

    modal.addEventListener('click', (event) => {
      if (event.target === modal) setDismissed();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.hasAttribute('open')) setDismissed();
    });

    modal.show();
  });
})();
